export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_RESTAURANT_ID = 'SET_RESTAURANT_ID';
export const SET_RESTAURANT_NAME = 'SET_RESTAURANT_NAME';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_ITEMS_BY_CATEGORIES = 'SET_ITEMS_BY_CATEGORIES';
export const SET_RESTAURANT_INFO = 'SET_RESTAURANT_INFO';
export const SET_POSTS_FEED = 'SET_POSTS_FEED';
export const SET_RESTAURANT_NOT_FOUND = 'SET_RESTAURANT_NOT_FOUND';
export const SET_CATEGORIES_GRAPH = 'SET_CATEGORIES_GRAPH';
export const SET_DISHES_BY_CATEGORY_GRAPH_LOOKUP = 'SET_DISHES_BY_CATEGORY_GRAPH_LOOKUP';
export const SET_DISHES_LOOKUP = 'SET_DISHES_LOOKUP'